import api from "../lib/api";

export function deleteConfirmDialog(onOk?: () => Promise<unknown>, param?: { title?: string; confirmText?: string; helperText?: string }) {
  const confirmText = param?.confirmText || "delete";
  const helperText = param?.helperText || "Once it's deleted, it cannot be recovered.";
  const title = param?.title || "Delete record?";
  return window.webApp.toggleConfirmDialog({
    title,
    onOk: onOk || (() => Promise.resolve()),
    confirmText,
    helperText,
    open: true,
  });
}

export function confirmDialog<T>(param: { title: string; onOk?: () => Promise<T>; helperText?: string }): Promise<T> {
  return window.webApp.toggleConfirmDialog({
    title: param.title,
    helperText: param.helperText,
    onOk: param.onOk || (() => Promise.resolve()),
    open: true,
  });
}

const html = `<div style="width: 100vw; padding-top: 20vh; text-align:center;font-size: 32px; font-weight:bold">{{content}}</div>`;

export async function openWindowInAsync(fn: () => Promise<string>, placeholder: string) {
  var w = window.open();
  w!.document.body.innerHTML = html.replace("{{content}}", placeholder || "Loading...");
  try {
    const link = await fn();
    w!.location.href = link;
  } catch (error: any) {
    w!.document.body.innerHTML = html.replace("{{content}}", `<p>Some error happened, please contact us.</p><p>${error.message}</p>`);
  }
}

export function sendClientHeightChange() {
  const chart = (window as any).ChartMessage;
  if (chart) {
    setTimeout(() => {
      chart.postMessage(JSON.stringify({ height: document.body.clientHeight }));
    }, 1000);
  }
}
